<template>
  <div>
    <div class="md-layout">
      <template v-for="(item, index) in media">
        <kab-card
          :key="index"
        >
          <template #card-image>
            <div
              class="boder-image-circle"
              @click="showModal(item)"
            >
              <img
                alt="kab logo"
                class="image-avatar"
                :src="`https://img.youtube.com/vi/${item.video_id}/0.jpg`"
              >
            </div>
          </template>
          <template #card-details>
            <div class="md-layout md-alignment-center-center"> 
              <h1 class="section-title">
                Artists
              </h1>
            </div>
            <div class="md-layout md-alignment-left-center user-name-1"> 
              <template v-for="(name, index1) in apprentices">
                <div :key="index1">
                  <p>{{ name.apprentice }}</p>
                </div>
              </template>
            </div>
          </template>
        </kab-card>
      </template>
    </div>
    <md-dialog
      :md-click-outside-to-close="false"
      :md-active.sync="showDialog"
      class="kabs-dailog"
    >
      <div class="md-layout kab-dialog-container">
        <youtube
          class="md-layout md-gutter video-preview-1"
          :video-id="videoId"
        />
      </div>
      <md-dialog-actions
        class="close-icon"
      >
        <i
          class="material-icons md-size-2x"
          @click="closeDialog"
        >
          clear
        </i>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import KabCard from '../KabCard'
export default {
  name: "StudioVideo",
  components: {
    KabCard
  },
  props: {
    project: {
      type: [Object, Array],
      default: () => []
    },
    author: {
      type: [Object, Array],
      default: () => []
    },
  },
  data() {
    return {
      videoId: '',
      showDialog: false,
      media: this.project,
      apprentices: this.author,

    }
  },
  watch: {
    project(value) {
      console.log(value)
      if (value.length > 0) {
        this.media = value
        return
      }
      this.media = []
    },
    author(value) {
      console.log(value)
      this.apprentices = value
    }
  },
  methods: {
    closeDialog() {
      this.showDialog = false
    },
    showModal(value) {
      console.log(value)
      this.videoId = value.video_id
      this.showDialog = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.user-name-1 {
  margin-left: 30px;
  p {
    margin-bottom: -5px;
  }
}
.video-preview-1 {
  iframe {
    width: 80%; 
    height: 70vh;
  }
  margin-bottom: 30px;
}

.boder-image-circle {
  cursor: pointer;
}
@media only screen and (max-width: 600px) {
  .video-preview-1 {
    iframe {
      width: 100%; 
      height: 70vh;
    }
  }
}
</style>
